import { render, staticRenderFns } from "./PrasymasTurtas.vue?vue&type=template&id=ba23cdb6&scoped=true&"
import script from "./PrasymasTurtas.vue?vue&type=script&lang=js&"
export * from "./PrasymasTurtas.vue?vue&type=script&lang=js&"
import style0 from "./PrasymasTurtas.vue?vue&type=style&index=0&id=ba23cdb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba23cdb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VDivider,VRow})
